




































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters, mapState, mapActions } from 'vuex';

import { ServerResult } from '@/core/http/server_result';
import { QueryBuilder } from '@/core/uql';

@Component
export default class Combobox extends Vue {
  $db!: (queries: any[]) => Promise<ServerResult>
  $q!: (queryName: string) => QueryBuilder;

  @Prop() value!: any;
  @Prop({ type: String }) schema!: string;
  @Prop({ type: String }) scope!: string;
  @Prop({ type: Array }) data!: any[];
  @Prop({ type: String }) keyField!: string;
  @Prop({ type: String }) labelField!: string;
  @Prop({ type: String }) order!: string;

  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  @Prop() labelObject!: any;

  @Prop({ type: String }) relField!: string;
  @Prop({ type: String }) relFilter!: string;
  @Prop({ type: String }) relFilterNull!: string;

  @Prop({ type: String }) position!: string;
  @Prop({ type: Boolean }) multiple!: boolean;
  @Prop({ type: Boolean }) filterArchived!: boolean;
  @Prop({ type: Boolean }) throwParent!: boolean;

  @Prop({ type: String }) placeholder!: string;
  @Prop({ type: String }) clearable!: boolean;
  @Prop({ type: Boolean }) extended!: string;
  @Prop({ type: Function }) prefilter!: Function;
  @Prop({ type: Boolean }) wrap!: boolean;
  @Prop({ type: Boolean }) type!: string;

  localValue: any = null
  selectdItemLabel: any = '';
  dropdownActive = false;

  items: any[] = [];
  itemsForDisplay: any[] = [];

  searchText: string = '';

  public created() {
    //
  }

  public mounted() {
    this.selectdItemLabel = this.placeholder;

    if (this.schema) {
      this.loadData();
    } else {
      this.items = this.data;
      this.updateValue(this.value);
      this.updateDisplayList();
    }
  }

  public loadData() {
    const QNAME = `SELECT_COMBOBOX_LIST_${this.schema.toUpperCase()}`;

    if (this.relField && !(this.relFilter || this.relFilterNull)) {
      return;
    }
    const fields: any = {
        id: `${this.schema}.${this.keyField}`,
        label: this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`,
    }

    const query = this.$q(QNAME)
      .select()
      .fileds(fields)
      .order((_: any) => {
          if (this.order) {
            return [
              _[this.order]([`${this.schema}.${this.labelField}`]),
          ];
          }
          return [
              _.asc([`${this.schema}.${this.labelField}`]),
          ];
      })
      .from(this.schema)
      .where((_: any) => {
        if(this.relField) {
          if (this.relFilterNull) {
            return _.null([`${this.schema}.${this.relField}`]);
          } else {
            if (this.throwParent && this.relField == 'client_id') {
              return _.or([
                _.eq(`view_client_parents.id`, _.const(this.relFilter)),
                _.eq(`view_client_parents.client_id`, _.const(this.relFilter))
              ]);
            } else {
              return _.eq(`${this.schema}.${this.relField}`, _.const(this.relFilter));
            }
          }
        } else {
          return undefined;
        }
      })
      .limit(100000);

    switch(this.scope) {
      case 'drivers': {
        query.innerJoin('employee_vehicles', (_: any) => {
          return _.eq('employee_vehicles.employee_id', 'employees.id');
        })

        break;
      }
      case 'linked': {
        query.innerJoin('departments', (_: any) => {
          return _.eq('departments.id', 'employees.department_id');
        })

        break;
      }

    }

    switch(this.schema) {
      case 'clients': {
        query
          .fileds({
            id: `${this.schema}.${this.keyField}`,
            label: this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`,
            payment_type_id: `${this.schema}.payment_type_id`,
            delivery_warehouse_id: `${this.schema}.delivery_warehouse_id`,
            destination_warehouse_id: `${this.schema}.destination_warehouse_id`,
            manager_id: `${this.schema}.manager_id`,
            type_id: `${this.schema}.type_id`,
          })

        break;
      }
      case 'delivery_zones': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: { $concat: ['delivery_zones.name', {$: ' ('}, 'delivery_zone_groups.name', {$: ')'} ] },
          })
          .innerJoin('delivery_zone_groups', (_: any) => {
            return _.eq('delivery_zone_groups.id', 'delivery_zones.delivery_zone_group_id');
          })

        break;
      }
      case 'delivery_points': {
        if (this.throwParent) {
          query
            .innerJoin('view_client_parents', (_: any) => {
              return _.eq('view_client_parents.client_id', `${this.schema}.${this.relField}`);
            })
        }
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`,
              delivery_delay: 'delivery_zone_groups.delivery_delay',
              archived_at: `${this.schema}.archived_at`,
              counterparty_id: `${this.schema}.counterparty_id`,
              client_id: `${this.schema}.client_id`,
              client_name: `clients.name`,
              delivery_zone_id: `delivery_zones.id`,
              week_days: {
                $array_agg: {
                  $obj: {
                    week_day: "delivery_date_schedule.week_day",
                    is_allow: "delivery_date_schedule.is_allow",
                    time: "delivery_date_schedule.time",
                    delivery_point_id: 'delivery_date_schedule.delivery_point_id'
                  }
                }
              }
          })
          .innerJoin('delivery_points_delivery_zones', (_: any) => {
            return _.eq('delivery_points_delivery_zones.delivery_point_id', 'delivery_points.id');
          })
          .innerJoin('delivery_zones', (_: any) => {
            return _.eq('delivery_zones.id', 'delivery_points_delivery_zones.delivery_zone_id');
          })
          .innerJoin('delivery_zone_groups', (_: any) => {
            return _.eq('delivery_zone_groups.id', 'delivery_zones.delivery_zone_group_id');
          })
          .innerJoin('clients', (_: any) => {
            return _.eq('clients.id', 'delivery_points.client_id');
          })
          .leftJoin('delivery_date_schedule', (_: any) => {
            return _.or([
              _.and([
                _.eq('delivery_date_schedule.delivery_zone_id', 'delivery_zones.id'),
                _.null(['delivery_date_schedule.delivery_point_id'])
              ]),
              _.eq('delivery_date_schedule.delivery_point_id', 'delivery_points.id')
            ])
          })
          .group([
              `${this.schema}.${this.keyField}`,
              this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`,
              'delivery_zone_groups.delivery_delay',
              `${this.schema}.archived_at`,
              `${this.schema}.counterparty_id`,
              `${this.schema}.client_id`,
              `clients.name`,
              'delivery_zones.id'
          ])
        break;
      }
      case 'deals': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: 'delivery_points.address',
              date: 'deals.expected_delivery_date',
          })
          .leftJoin('delivery_points', (_: any) => {
            return _.eq('delivery_points.id', 'deals.delivery_point_id')
          })

        break;
      }
      case 'counterparties': {
        if (this.throwParent) {
          query
            .innerJoin('view_client_parents', (_: any) => {
              return _.eq('view_client_parents.client_id', `${this.schema}.${this.relField}`);
            })
        }
        if (this.extended) {
          query
            .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: { $concat: [this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`, {$: ' ('}, 'delivery_points.address', {$: ')'} ] },
              delivery_point_id: 'delivery_points.id'
            })
            .leftJoin('delivery_points', (_: any) => {
              return _.and([
                _.eq('delivery_points.counterparty_id', 'counterparties.id'),
                _.null(['delivery_points.archived_at']),
              ])
            })
        } else {
          query
            .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`,
            })
        }

        break;
      }
      case 'vehicles': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: {$concat: ['vehicles.model', {$: ' ('}, 'vehicles.number', {$: ')'}]},
          })
        break;
      }
      case 'product_containers': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: this.labelObject ? `${this.schema}.${this.labelObject}` : `${this.schema}.${this.labelField}`,
              name: `${this.schema}.name`,
              position: `${this.schema}.position`,
              weight: `${this.schema}.weight`,
              volume: `${this.schema}.volume`,
              price: `${this.schema}.price`,
              is_sample: `${this.schema}.is_sample`,
              barcode: `${this.schema}.barcode`,
              sku: `${this.schema}.sku`,
              price_per_kg: `${this.schema}.price_per_kg`
          })
        break;
      }
      case 'voc_containers': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: `${this.schema}.${this.labelField}`,
              weight: 'voc_containers.weight',
              tare_weight: 'voc_containers.tare_weight'
          })
          break;
      }
      case 'shift_plan_vdp': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: { $concat: [{$: 'партия '}, 'shift_plan_vdp.number', {$: ' - '}, 'voc_bases.name'] },
          })
          .leftJoin('voc_bases', (_: any) => {
            return _.eq('shift_plan_vdp.base_id', 'voc_bases.id')
          })
          .order((_: any) => {
            return [
              _.asc([`shift_plan_vdp.id`]),
            ];
          })
        break;
      }
      case 'shift_fact_vdp': {
        query
          .fileds({
              id: `${this.schema}.${this.keyField}`,
              label: 'voc_bases.name',
              quantity: 'shift_fact_vdp.quantity',
              weight_neto: 'shift_fact_vdp.weight_neto',
          })
          .leftJoin('shift_plan_vdp', (_: any) => {
            return _.eq('shift_plan_vdp.id', 'shift_fact_vdp.shift_plan_id')
          })
          .leftJoin('voc_bases', (_: any) => {
            return _.eq('shift_plan_vdp.base_id', 'voc_bases.id')
          })
          .where((_: any) => {
            if(this.relField) {
              if (this.relFilterNull) {
                return _.null([`shift_plan_vdp.${this.relField}`]);
              } else {
                return _.eq(`shift_plan_vdp.${this.relField}`, _.const(this.relFilter));
              }
            } else {
              return undefined;
            }
          })
          .order((_: any) => {
            return [
              _.asc([`shift_fact_vdp.id`]),
            ];
          })
        break;
      }
    }

    if (this.filterArchived) {
      if (this.schema == 'employees') {
        // @ts-ignore
        query.columnMap.archived_at = `${this.schema}.fired_at`
      } else {
        // @ts-ignore
        query.columnMap.archived_at = `${this.schema}.archived_at`
      }
    }

    this.$db([
      query,
    ]).then(((result: ServerResult) => {
      this.items = result.getOperation(QNAME).getContent().documents;

      if(this.multiple && !Array.isArray(this.value)) {
        this.onValueChange([this.value]);
      } else {
        this.onValueChange(this.value);
      }
      this.updateDisplayList()
    }));
  }

  @Watch('value')
  onValueChange(newVal: any) {
    // console.log(newVal);
    this.localValue = newVal;

    if (this.localValue) {
      if(Array.isArray(this.localValue)) {
        const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

        if (selectdItems.length > 0) {
          this.selectdItemLabel = selectdItems.map(item => item.label).join(', ');
        } else {
          this.selectdItemLabel = ''
        }

      } else {
        const selectdItem = this.items.find((item) => item.id == this.localValue);

        if (selectdItem) {
          this.selectdItemLabel = selectdItem.label;
        } else {
          this.selectdItemLabel = ''
        }
      }
    } else {
      this.selectdItemLabel = ''
    }

  }

  @Watch('relFilter')
  onRelFilterChange(newVal: any) {
    console.log('onRelFilterChange');
    this.updateValue(null);
    this.loadData();
  }

  updateValue(value: any) {
    console.log('value => ', value);
    this.onValueChange(value);


    if(Array.isArray(this.localValue)) {
      this.$emit('input', value.filter((item: any) => item));
      const selectdItems = this.items.filter((item) => this.localValue.includes(item.id));

      this.$emit('input-object', selectdItems);
      this.$emit('input-native', selectdItems);

    } else {
      this.$emit('input', value);
      const selectdItem = this.items.find((item) => item.id == this.localValue);

      this.$emit('input-object', selectdItem);
      this.$emit('input-native', selectdItem);
    }
  }

  activeChange($event: any) {
    this.dropdownActive = $event;
    console.log('this.dropdownActive', this.dropdownActive, this.$refs.searchInput);
    if (this.dropdownActive) {
      (this.$refs.searchInput as any).focus()
    }
  }

  @Watch('searchText')
  updateDisplayList() {
    let items = (this.items || [])
    if (this.prefilter) {
      items = items.filter((item: any, index: number) => {
        return this.prefilter(item, index)
      })
    }
    this.$set(this, 'itemsForDisplay', items.filter((item: any) => {
      if (this.filterArchived) {
        return !item.archived_at ? (item.label || '').toLowerCase().includes(this.searchText) : null;
      } else {
        return (item.label || '').toLowerCase().includes(this.searchText);
      }
    }))
  }

  clear() {
    console.log('clear')
    this.updateValue(null)
  }

  // search($event) {
  //   throttle
  // }
}
